"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var matchCurrentDate_1 = require("./matchCurrentDate");
Object.defineProperty(exports, "default", { enumerable: true, get: function () { return matchCurrentDate_1.default; } });
//# sourceMappingURL=index.js.map